import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { SharedModule } from '@shared/shared.module';
import { CoreModule } from '@core/core.module';
import { LocationComponent } from '@app/features/locations/modules/location/location.component';
import { LocationClosuresComponent } from '@app/features/locations/components/location-closures/location-closures.component';

@NgModule({
    imports: [
        CommonModule,
        CoreModule,
        SharedModule
    ],
    declarations: [
        LocationComponent,
        LocationClosuresComponent
    ],
    providers: [],
    exports: [],
    bootstrap: []
})
export class LocationModule {}